var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      attrs: {
        width: "427",
        right: "",
        temporary: "",
        fixed: "",
        "overlay-opacity": 0,
      },
      on: { input: _vm.onChange },
      model: {
        value: _vm.drawer,
        callback: function ($$v) {
          _vm.drawer = $$v
        },
        expression: "drawer",
      },
    },
    [
      _c(
        "v-container",
        {
          staticClass:
            "d-flex flex-column justify-space-around pa-0 fill-height",
          attrs: { fluid: "" },
        },
        [
          _c(
            "v-toolbar",
            {
              staticClass: "pr-3",
              staticStyle: { width: "100%" },
              attrs: { flat: "", dense: "" },
            },
            [
              _c(
                "v-toolbar-title",
                { staticClass: "text-subtitle-2" },
                [
                  _c(
                    "v-list-item-title",
                    { staticClass: "table-subttile text--primary" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.curRow
                            ? _vm.$getCommonLangValue(
                                _vm.curRow["leave_type_name"]
                              )
                            : _vm.$t(
                                "label_essweb_leaveBalance_list_title_detail"
                              )
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-tooltip",
                {
                  attrs: { left: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              {
                                attrs: { icon: "", color: "black", small: "" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    _vm.drawer = false
                                  },
                                },
                              },
                              on
                            ),
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons-round" },
                                [_vm._v("close")]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "label_essweb_RosterRecord_slide_adhoc_closeBtnTip"
                        )
                      )
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "v-container",
            {
              staticClass: "pa-0 scroll_content_no mrc-grey",
              style: { height: "calc(100% - 108px)" },
              attrs: { fluid: "" },
            },
            [
              _vm.taber.length > 0
                ? _c(
                    "Taber",
                    {
                      attrs: {
                        curTab: _vm.curTab,
                        items: _vm.taber,
                        border: "",
                        closeTranslate: "",
                        height: 40,
                        special: "",
                        rounded: false,
                        contentBackground: "fill-height",
                        backgroundColor: "white",
                      },
                      on: {
                        change: function (tab) {
                          return (_vm.curTab = tab)
                        },
                      },
                    },
                    [
                      _vm._l(_vm.taber, function (item, index) {
                        return _c(
                          "template",
                          { slot: "content-" + (index + 1) },
                          [
                            _c(
                              "v-row",
                              { key: "balance" + index, attrs: { dense: "" } },
                              [
                                _c(
                                  "v-col",
                                  {
                                    attrs: {
                                      xs: "12",
                                      sm: "12",
                                      md: "12",
                                      lg: "12",
                                      cols: "12",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-container",
                                      {
                                        staticClass: "pa-0 ma-0",
                                        attrs: { fluid: "" },
                                      },
                                      _vm._l(_vm.headers, function (header, i) {
                                        return header.value !== "action"
                                          ? _c(
                                              "v-sheet",
                                              { key: "header" + i },
                                              [
                                                _c("v-divider"),
                                                _c(
                                                  "v-sheet",
                                                  {
                                                    staticClass:
                                                      "d-flex text-body-m pa-4 align-center",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(header.text) +
                                                        " "
                                                    ),
                                                    _c("v-spacer"),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.getText(
                                                            header,
                                                            _vm.deserts[index]
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c("v-divider"),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "pa-4 mrc-grey",
                                    attrs: {
                                      xs: "12",
                                      sm: "12",
                                      md: "12",
                                      lg: "12",
                                      cols: "12",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-sheet",
                                      {
                                        staticClass: "primary rounded-lg pa-4",
                                        attrs: { elevation: 3 },
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "text-h6 transparent white--text",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_leaveBalance_form_futureBalanceLabel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "\n                    text-right text-h3\n                    transparent\n                    white--text\n                    font-weight-bold\n                  ",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getText(
                                                  _vm.headers.find(function (
                                                    ele
                                                  ) {
                                                    return (
                                                      ele.value ===
                                                      "leave_future_balance"
                                                    )
                                                  }),
                                                  _vm.deserts[index],
                                                  false
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "text-right text-caption transparent white--text",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.deserts[index]["unit"] ===
                                                  "D"
                                                  ? _vm.$t(
                                                      "label_essweb_system_dayLabel"
                                                    )
                                                  : _vm.deserts[index][
                                                      "unit"
                                                    ] === "H"
                                                  ? _vm.$t(
                                                      "label_essweb_system_hourLabel"
                                                    )
                                                  : ""
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.deserts[index]["last_sync_updated_date"]
                                  ? _c(
                                      "v-col",
                                      {
                                        staticClass:
                                          "text-center text--secondary mrc-grey text-caption",
                                        attrs: {
                                          xs: "12",
                                          sm: "12",
                                          md: "12",
                                          lg: "12",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_leaveBalance_form_lastestUpdateTime"
                                              )
                                            ) +
                                            ":" +
                                            _vm._s(
                                              _vm.$getDateTime(
                                                _vm.deserts[index][
                                                  "last_sync_updated_date"
                                                ],
                                                "YYYY/MM/DD"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _c("noContent"),
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-sheet",
            {
              staticClass:
                "\n        align-center\n        text-center\n        flex-row\n        d-flex\n        justify-center\n        max-width\n      ",
              staticStyle: {
                "border-top": "1px solid var(--main-border-color)",
              },
              attrs: { height: "60" },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "pl-7 pr-7 text-capitalize mr-2",
                  attrs: { color: "primary", height: "32", rounded: "" },
                  on: {
                    click: function ($event) {
                      _vm.drawer = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("label_shut_down")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }